// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function Select(): any {
  return {
    MuiSelect: {
      defaultProps: {
        MenuProps: {
          anchorOrigin: { vertical: "bottom", horizontal: "center" },
          transformOrigin: { vertical: "top", horizontal: "center" },
        },
      },
    },
  };
}
